/**
 * Upcoming Listings module constants.
 */

// How far ahead the view looks. Stated in the page subtitle rather than applied
// silently, so a broker is never surprised by a listing that is missing simply
// because it goes live later than this.
export const UPCOMING_WINDOW_DAYS = 30;

export const LISTINGS_PAGE_SIZE = 12;

// Go-live date first: a meeting works through listings in the order they reach
// the market.
export const UPCOMING_SORT_OPTIONS = [
  { value: "go-live-date", label: "Go-live date" },
  { value: "p-low-high", label: "Price: low to high" },
  { value: "p-high-low", label: "Price: high to low" },
  { value: "new-old", label: "Recently added" },
];

export const DEFAULT_SORT = "go-live-date";

export const ALL_AGENTS = "all";

export const NEEDS_PAGE_SIZE = 20;

export const NEEDS_SORT_OPTIONS = [
  { value: "new-old", label: "Newest first" },
  { value: "old-new", label: "Oldest first" },
];

export const DEFAULT_NEEDS_SORT = "new-old";

// Declared in the order the tab bar renders them.
export const TABS = {
  LISTINGS: "listings",
  NEEDS: "needs",
  OPEN_HOUSES: "openhouses",
};

// Soonest first: an unstaffed open house this Saturday matters more than one
// three weeks out.
// Same wording as NEEDS_SORT_OPTIONS so the two tabs read alike. The values
// stay open-house specific because the server branches on them.
//
// "Oldest" is the earliest date, which for upcoming open houses is the one
// happening next — so it leads, and it is the default a meeting wants.
export const OPEN_HOUSE_SORT_OPTIONS = [
  { value: "soonest", label: "Oldest first" },
  { value: "latest", label: "Newest first" },
];

// How many siblings the detail view pulls to drive Prev / Next. A meeting works
// through a handful of listings, not hundreds, so one page is enough — and it
// keeps the detail view to a single extra query.
export const SIBLING_FETCH_LIMIT = 100;
